export default __webpack_public_path__ + "static/media/PPI-garden-bed-009.a7f94c27.jpg";